import api from "./Api";

class CTeService {
  GetCTe(payload) {
    return api.get("/v1/CTe/" + payload).then((response) => {
      return response.data;
    });
  }

  PostCTe(payload) {
    return api.post("/v1/CTe", payload).then((response) => {
      return response.data;
    });
  }

  PutCTe(payload) {
    return api.put("/v1/CTe", payload).then((response) => {
      return response.data;
    });
  }

  DeleteCTe(payload) {
    return api.delete("/v1/CTe/" + payload).then((response) => {
      return response.data;
    });
  }

  GetCTeOData(payload) {
    return api.get("/OData/CTe" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new CTeService();
